import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import $ from "jquery";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import CustomRangepicker from "../../common/rangepicker";
import { TrimText, formateDateWithMonth } from "../../../../utils/commonfunction";
import * as iapTransactionServices from "../../services/iapTransaction.services";
import { useTranslation } from "react-i18next";

const CURRENCY_SYMBOLS = {
  INR: "₹",
  USD: "$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  AUD: "A$",
  CAD: "C$",
};

const formatCurrency = (amount, currency) => {
  if (amount === null || amount === undefined) return "N/A";
  const symbol = currency ? (CURRENCY_SYMBOLS[currency.toUpperCase()] || currency + " ") : "";
  return `${symbol}${amount}`;
};

const EVENT_TYPE_COLORS = {
  PURCHASE: "badge-success",
  RENEWAL: "badge-info",
  RESTORE: "badge-primary",
  CANCEL: "badge-warning",
  EXPIRED: "badge-secondary",
  REFUND: "badge-danger",
  REVOKE: "badge-danger",
  GRACE_PERIOD: "badge-warning",
  FAIL_TO_RENEW: "badge-danger",
  OFFER_REDEEMED: "badge-info",
  PRICE_INCREASE: "badge-secondary",
  OTHER: "badge-secondary",
};

const IapTransactionTable = () => {
  const params = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [datalength, setDataLength] = useState();
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [resetdate, setResetDate] = useState(false);
  const [eventTypeFilter, setEventTypeFilter] = useState("");
  const [platformFilter, setPlatformFilter] = useState("");

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    // { title: t("sidebar_link_subscribe"), url: "" },
    { title: t("sidebar_link_transactions"), url: "" },
  ];

  useEffect(() => {
    const getData = setTimeout(() => {
      setLoader(true);
      const formData = new FormData();
      formData.append("page", params.pgno);
      formData.append("per_page", itemperpage);
      formData.append("sort", JSON.stringify(sorting));
      formData.append("search", JSON.stringify(search));
      formData.append("global_search", globalsearch);
      iapTransactionServices
        .List(formData)
        .then((data) => {
          setDataLength(data?.data?.total_records);
          setList(data?.data?.list ?? []);
          setLoader(false);
        })
        .catch((error) => {
          console.log("error ====> ", error);
          setLoader(false);
        });
    }, 300);

    return () => clearTimeout(getData);
  }, [location, sorting, search, globalsearch]);

  const viewFunction = (row) => {
    navigate(`/admin/transactions/view/${row._id}`);
  };

  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column };
    sort.order = e.target.classList.contains("assc") ? -1 : 1;
    setSorting(sort);
  };

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    setSearch({});
    setResetDate(!resetdate);
    setEventTypeFilter("");
    setPlatformFilter("");
    $("#filter_event_type")[0].selectedIndex = 0;
    $("#filter_platform")[0].selectedIndex = 0;
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card overflow-hidden">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">{t("sidebar_link_transactions")}</h6>
              <div className="d-flex align-items-center flex-wrap gap-2">
                {/* Global search */}
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => setGlobalSearch(e.target.value)}
                    />
                  </div>
                </div>

                {/* Date range */}
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => prepareSearch("createdAt", e)}
                    resetdate={resetdate}
                  />
                </div>

                {/* Event type filter */}
                <div className="me-3">
                  <select
                    id="filter_event_type"
                    className="form-control"
                    value={eventTypeFilter}
                    onChange={(e) => {
                      setEventTypeFilter(e.target.value);
                      prepareSearch("event_type", e.target.value);
                    }}
                  >
                    <option value="">All Event Types</option>
                    {Object.keys(EVENT_TYPE_COLORS).map((type) => (
                      <option key={type} value={type}>
                        {type.replace(/_/g, " ")}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Platform filter */}
                <div className="me-3">
                  <select
                    id="filter_platform"
                    className="form-control"
                    value={platformFilter}
                    onChange={(e) => {
                      setPlatformFilter(e.target.value);
                      prepareSearch("platform", e.target.value);
                    }}
                  >
                    <option value="">All Platforms</option>
                    <option value="ios">iOS</option>
                    <option value="android">Android</option>
                  </select>
                </div>

                <button
                  type="reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  {t("btn_reset_filter")}
                </button>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered border-t0 card-table text-nowrap w-100">
                <thead>
                  <tr>
                    <th className="sr_head">{t("list_heading_sno")}</th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("list_heading_name")}</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="user.full_name" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("list_heading_email")}</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="user.email" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Plan</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="subscription_plan.title" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Event Type</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="event_type" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Platform</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="platform" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Paid Amount</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="paid_amount" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Purchase Date</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="purchase_date" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("list_heading_created_date")}</span>
                        <Sorting
                          sort={sorting}
                          defaultSorting={defaultSorting}
                          handleSort={handleSort}
                          column="createdAt"
                        />
                      </div>
                    </th>
                    <th className="action_head">{t("list_heading_action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={10}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length ? (
                        list.map((row, i) => (
                          <tr key={row._id}>
                            <td>{(page - 1) * itemperpage + i + 1}</td>
                            <td>
                              {row?.user?.full_name
                                ? TrimText(row.user.full_name, 25)
                                : row?.user?.first_name
                                ? TrimText(
                                    `${row.user.first_name} ${row.user.last_name || ""}`.trim(),
                                    25
                                  )
                                : "N/A"}
                            </td>
                            <td>{row?.user?.email ? TrimText(row.user.email, 30) : "N/A"}</td>
                            <td>{row?.subscription_plan?.title ? TrimText(row.subscription_plan.title, 25) : "N/A"}</td>
                            <td>
                              <span className={`badge ${EVENT_TYPE_COLORS[row?.event_type] || "badge-secondary"}`}>
                                {row?.event_type ? row.event_type.replace(/_/g, " ") : "N/A"}
                              </span>
                            </td>
                            <td className="text-uppercase">{row?.platform || "N/A"}</td>
                            <td>{formatCurrency(row?.paid_amount, row?.currency)}</td>
                            <td>{row?.purchase_date ? formateDateWithMonth(row.purchase_date) : "N/A"}</td>
                            <td>{row?.createdAt ? formateDateWithMonth(row.createdAt) : "N/A"}</td>
                            <td>
                              <button
                                className="btn ripple btn-main-primary signbtn"
                                onClick={() => viewFunction(row)}
                              >
                                {t("btn_view")}
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={10} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>

            <div role="status" aria-live="polite">
              <b>
                {t("msg_total_records")} : {datalength ?? "0"}
              </b>
            </div>

            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                setPage={setPage}
                currentPage={page}
                pageRoute={[
                  { name: "IapTransactionTable", path: "/admin/transactions/list" },
                ]}
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default IapTransactionTable;
